/**
 * Created by pajicv on 10/2/18.
 */
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import ProjectCard from './ProjectCard';
import ProjectList from './ProjectList';
import { spinnerWhileLoading } from '../../utils/components';

const populateCycles = [{
    root: 'cycles',
    child: 'cycles',
    populateByKey: true
}]

const enhance = compose(
    connect(
        (state, props) => {
            const { projectId } = props;
            return ({
                auth: state.firebase.auth,
                members: populate(state.firebase, `projects/${projectId}/members`, []),
                projectCycles: populate(state.firebase, `projects/${projectId}`, populateCycles),
                ...props
            });
        }
    ),
    firebaseConnect((props) => {
        const { projectId } = props;
        return [
            { path: `projects/${projectId}/members` },
            { path: `projects/${projectId}`, populates: populateCycles }
        ];
    }),
    spinnerWhileLoading(['projectCycles'])
);

const ProjectListEnhance = enhance(ProjectList);
const ProjectCardEnhance = enhance(ProjectCard);
export {
    ProjectCardEnhance,
    ProjectListEnhance
};



// WEBPACK FOOTER //
// ./src/components/common/ProjectCard.enhancer.js